import { Outlet, useLocation } from "react-router-dom";
import Footer from '../components/Footer';
import Header from '../components/Header';
import React, { useEffect } from 'react';
const Layout = () => {
  const location = useLocation();
  const hideFooterRoutes = ["/404", "/thank-you"];
  const shouldHideFooter = hideFooterRoutes.includes(location.pathname);
  const isHome = location.pathname === "/";

    useEffect(() => {
    const body = document.body;
    if (hideFooterRoutes.includes(location.pathname)) {   body.classList.add("overflow-page");  
    } else { body.classList.remove("overflow-page");
    }
    return () => {
      body.classList.remove("overflow-page");
    };
  }, [location.pathname]);


  return (
    <div>
      <div className={isHome ? "header-bg" : ""}>
        <Header />
        <main>
          <Outlet />
        </main>
        {!shouldHideFooter && <Footer />}
      </div>
    </div>
  );
};

export default Layout;
